import {Component, forwardRef, Input} from '@angular/core';
import {FormBuilder, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';
import {EMPTY, Observable} from 'rxjs';
import {CommonModule} from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {LocationService} from '../../../services/location.service';
import {InputAutocompleteComponent} from '../input-autocomplete/input-autocomplete.component';
import {Location, locationDisplayFunction} from '../../../services/model';
import {TranslocoDirective} from '@jsverse/transloco';

@Component({
  selector: 'app-location-autocomplete',
  templateUrl: '../input-autocomplete/input-autocomplete.component.html',
  styleUrls: ['../input-autocomplete/input-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocationAutocompleteComponent),
      multi: true
    }
  ],
  standalone: true,
  imports: [CommonModule, MatAutocompleteModule, ReactiveFormsModule, MatFormFieldModule,
    MatIconModule, TranslocoDirective, MatInputModule, MatSelectModule, MatSelectModule, MatIconModule, FormsModule]
})
export class LocationAutocompleteComponent extends InputAutocompleteComponent<Location> {

  constructor(fb: FormBuilder, private locationService: LocationService) {
    super(fb);
  }

  private _merchantId?: string;

  @Input() set merchantId(value: string | undefined) {
    this._merchantId = value;
    this.reset();
  }

  override getPlaceholder(): string {
    return 'autocomplete.locations.placeholder';
  }

  override getData(textPatten: string): Observable<Location[]> {
    if (this._merchantId) {
      return this.locationService.findByNameMatchingText(this._merchantId!, textPatten);
    } else {
      return EMPTY;
    }

  }

  override getDisplayFn(): (id: Location) => string {
    return (option: Location): string => {
      if (option?.address) {
        return locationDisplayFunction(option);
      } else {
        return '';
      }
    }
  }
}

